export const maxWidth = 600
